import gql from "graphql-tag";

export const SEARCH_AUDIT_LOGS = gql`
query SearchAuditLogs($from: String!, $to: String) {
  auditLogs(from: $from, to: $to) {
    trxId
    userId
    user {
      firstName
      lastName
    }
    logs {
      id
      ts
      actionType
      changeType
      entity {
        id
        type
        name
      }
      field
      oldValue
      newValue
    }
  }
}
`;

export const GET_AUDIT_ENTITY = gql`
query GetAuditEntity($id: ID!, $type: String!) {
  auditEntity(id: $id, type: $type) {
    id
    type
    name
  }
}
`;
